
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { loginActions } from 'src/modules/Auth/store/actions';
import { useHistory } from 'react-router';
import { RoutesModules } from 'src/modules/Routing/types';
export type IOpenMenuItem = {
  [key in keyof typeof RoutesModules]: boolean
}
export interface INavBarState {
  isOpen: boolean,
  isOpenMenuItem: Partial<IOpenMenuItem>,
  toggleSettings: boolean,
  isMobile: boolean
};
export interface INavBarActions {
  toggle: () => void;
  toggleSettings: () => void;
  toggleMenuItems: (item: RoutesModules) => void;
  logout: () => void;
}

export const useNavState = (): [INavBarState, INavBarActions] => {
  const history = useHistory();
  const dispatch = useDispatch()
  const [state, setState] = React.useState<INavBarState>({
    isOpen: false,
    isOpenMenuItem: {},
    toggleSettings: false,
    isMobile: window.innerWidth < 800
  });
  React.useEffect(() => {
    window.addEventListener("resize", () => {
      if (state.isMobile && window.innerWidth > 800) {
        setState((currentState) => ({ ...currentState, isMobile: false }))
      }
      if (!state.isMobile && window.innerWidth < 800) {
        setState((currentState) => ({ ...currentState, isMobile: true }))
      }
    });
  }, [state.isMobile])
  const logout = React.useCallback(() => dispatch(loginActions.logout(history)), [dispatch]);
  const toggle = React.useCallback(() => {
    setState(currentState => {
      return {
        ...currentState,
        isOpen: !currentState.isOpen,
        isOpenMenuItem: {}
      }
    });
  }, [state]);
  const toggleSettings = React.useCallback(() => {
    setState(currentState => {
      return {
        ...currentState,
        toggleSettings: !currentState.toggleSettings
      }
    });
  }, [state]);
  const toggleMenuItems = React.useCallback((item: string) => {
    setState(currentState => {
      return {
        ...currentState, isOpenMenuItem: {
          [item]: !!!currentState.isOpenMenuItem[item]
        }
      }
    })
  }, []);
  const actions = React.useMemo(() => ({ toggle, toggleSettings, toggleMenuItems, logout }), [])
  return [state, actions]
}


// WEBPACK FOOTER //
// ./src/modules/Navigation/NavBar/hooks/useNavState.tsx